import { render, staticRenderFns } from "./TabSolunar.vue?vue&type=template&id=08fe93ca&scoped=true"
import script from "./TabSolunar.vue?vue&type=script&lang=js"
export * from "./TabSolunar.vue?vue&type=script&lang=js"
import style0 from "./TabSolunar.vue?vue&type=style&index=0&id=08fe93ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08fe93ca",
  null
  
)

export default component.exports